import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "16",
  fill: "none",
  viewBox: "0 0 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#23252C",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M1 4h12m0 0a3 3 0 1 0 6 0 3 3 0 0 0-6 0Zm-6 8h12M7 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    }, null, -1)
  ]))]))
}
export default { render: render }